import { render } from "./menuItemSession.vue?vue&type=template&id=b0a75c56&scoped=true"
import script from "./menuItemSession.vue?vue&type=script&lang=js"
export * from "./menuItemSession.vue?vue&type=script&lang=js"

import "./menuItemSession.vue?vue&type=style&index=0&id=b0a75c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a75c56"]])

export default __exports__